<template>
  <div v-if="filteredDates.length != 0" class="container">
    <h2 class="title">Fler datum</h2>
    <div class="carousel">
      <div class="carousel-cards" ref="carouselCards">
        <div v-for="(date) in filteredDates" :key="date.id" class="carousel-card" @click="goToDetails(date.id)">
          <div class="date">{{ formatDate(date.date) }}</div>
        </div>
      </div>
    </div>
    <div>
      <button class="scroll-left" @click="scrollLeft" v-if="canScrollLeft && !isMobile">
        <i class="fa fa-chevron-circle-left fa-2xl" aria-hidden="true"></i>
      </button>
      <button class="scroll-right" @click="scrollRight" v-if="canScrollRight && !isMobile">
        <i class="fa fa-chevron-circle-right fa-2xl" aria-hidden="true"></i>
      </button>
    </div>
  </div>

</template>


<script>
export default {
  name: "DateCarousel",
  data() {
    return {
      isMobile: false,
      canScrollLeft: false,
      canScrollRight: false
    };
  },
  props: {
    currentEventId: {
      type: String,
      required: true,
    },
    dates: {
      type: Array,
      required: true,
    },
  },
  async mounted() {
    this.checkMobile();
    this.checkScrollButtons();
  },
  computed: {
    // Computed property to filter out today's date
    filteredDates() {
      const now = new Date();
      return this.dates.filter(date => {
        const inputDate = new Date(date.date);
        return inputDate.getDate() !== now.getDate() || inputDate.getMonth() !== now.getMonth() || inputDate.getFullYear() !== now.getFullYear();
      });
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 568;
    },
    scrollLeft() {
      const container = this.$refs.carouselCards;
      if (container) {
        const cardWidth = container.scrollWidth / this.dates.length;
        container.scrollBy({ left: -cardWidth * 5, behavior: 'smooth' }); // Scroll by 2 cards
        if (container.scrollLeft == 0) {
          this.canScrollLeft = false;
        }
      }
    },
    scrollRight() {
      const container = this.$refs.carouselCards;
      if (container) {
        const cardWidth = container.scrollWidth / this.dates.length;
        container.scrollBy({ left: cardWidth * 5, behavior: 'smooth' }); // Scroll by 2 cards
      }
      this.canScrollLeft = true;
    },
    checkScrollButtons() {
      this.$nextTick(() => {
        const container = this.$refs.carouselCards;
        if (container) {
          const maxScroll = container.scrollWidth - container.clientWidth;
          console.dir(container.scrollLeft);
          console.dir(maxScroll);
          this.canScrollLeft = container.scrollLeft > 0;
          this.canScrollRight = container.scrollLeft < maxScroll;
        }
      });
    },
    goToDetails(id) {
      window.location.href = `/eventdetails/${id}`;
    },
    formatDate(dateString) {
      const now = new Date();
      const inputDate = new Date(dateString);

      if (
        inputDate.getFullYear() === now.getFullYear() &&
        inputDate.getMonth() === now.getMonth() &&
        inputDate.getDate() === now.getDate()
      ) {
        return "Idag";
      }

      const differenceInDays = Math.ceil((inputDate - now) / (1000 * 60 * 60 * 24));
      if (differenceInDays === 1) return "Imorgon";
      if (differenceInDays > 1 && differenceInDays <= 7) return `Om ${differenceInDays} dagar`;

      return dateString.split("T")[0];
    },
  },
};
</script>

<style scoped>
/* Left and Right navigation buttons */
.scroll-left {
  float: left;
  left: 7px;
}

.scroll-right {
  float: right;
  right: 5px;
}

/* Navigation buttons for scrolling */
.scroll-left,
.scroll-right {
  color: white;
  position: relative;
  top: 25px;
  background-color: #ffa500;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.container {
  position: relative;
  left: -10px;
  width: 104%;
}

.title {
  padding-top: 30px;
  margin-bottom: 10px;
  text-align: left;
}

.carousel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* Align carousel cards to the left */
  width: 100%;
  /* background-color: #ffa500; */
}

.carousel-cards {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 1px 0;
  width: 100%;
}

.carousel-card {
  flex: 0 0 auto;
  min-width: 100px;
  height: 40px;
  background: linear-gradient(135deg, #2A2A2A, #2A2A2A);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

.carousel-card:hover {
  background: linear-gradient(135deg, #2A2A2A, #2A2A2A);
  transform: scale(1.05);
}

.carousel-card.active {
  background: linear-gradient(135deg, #ffcc33, #ffa500);
  color: black;
  font-weight: bold;
}

.date {
  padding: 0 15px;
}

.carousel-cards::-webkit-scrollbar {
  display: none;
}

@media (max-width: 400px) {
  .title {
    font-size: 14px !important;
  }

  .carousel-card {
    min-width: 70px;
    height: 30px !important;
    font-size: 0.65rem;
    font-weight: 600;
  }
}
</style>
